
import request from '../util/request'


export function getMessage(data) {
  return request({
    url: 'admin/message',
    method: 'post',
    data:data
  })
}






  































// WEBPACK FOOTER //
// ./src/api/statistics.js